import request from "./request";
import session from "./session";
import { User } from "./user.entity";
import { UserPersonalInfo } from "./userPersonalInfo.entity";
import { UserAddress } from "./userAddress.entity";
import { UserProfessionalInfo } from "./userProfessionalInfo.entity";
import { UserBankAccount } from "./userBankAccount.entity";

export class UserService {
	static async signup({ email, password }) {
		const signupData = await request.send("auth", "signup", { email, password });
		await session.setSessionData(signupData);
		return true;
	}

	static async login({ email, password }) {
		const loginData = await request.send("auth", "login", { email, password });
		await session.setSessionData(loginData);
		return true;
	}

	static async logout() {
		try {
			request.send("auth", "logout", {}, true);
		} catch (error) {
	    // eslint-disable-line
		}
		await session.clear();
	}

	static async requestPasswordReset({ email }) {
		return request.send("auth", "requestPasswordReset", { email });
	}

	static async resetPassword({ passwordResetCode, password }) {
		return request.send("auth", "resetPassword", { passwordResetCode, password });
	}

	// Não implementado no backend
	static async changePassword({ email, newPassword }) {
		return request.send("auth", "changePassword", { email, newPassword }, true);
	}

	static async getRegistrationOptions() {
		return request.send("app/user", "getRegistrationOptions", {}, true);
	}

	static async updatePersonalInfo(info: UserPersonalInfo) {
		return request.send("app/user", "updatePersonalInfo", info, true);
	}

	static async updateAddress(info: UserAddress) {
		return request.send("app/user", "updateAddress", info, true);
	}

	static async updateProfessionalInfo(info: UserProfessionalInfo) {
		return request.send("app/user", "updateProfessionalInfo", info, true);
	}

	static async updateBankAccount(info: UserBankAccount) {
		return request.send("app/user", "updateBankAccount", info, true);
	}

	static async finishRegistration() {
		return request.send("app/user", "finishRegistration", {}, true);
	}
}
